export default __webpack_public_path__ + "static/media/7.16ddbf6e.svg";